import { render, staticRenderFns } from "./OrderFlowPage.vue?vue&type=template&id=1f41067d&scoped=true&"
import script from "./OrderFlowPage.vue?vue&type=script&lang=js&"
export * from "./OrderFlowPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f41067d",
  null
  
)

export default component.exports